const isNotThisDiscount = (discount, discountId) => {
  if (discount) {
    return discount.discountId !== discountId;
  }
  return false;
};

export default isNotThisDiscount;
